<template>
  <div class="content content-full">
    <div class="page-navs bg-white">
      <div class="nav-scroller">
        <div
          class="nav nav-tabs nav-line nav-color-secondary d-flex align-items-center justify-contents-center w-100"
        >
          <span class="nav-link" href="javascript:void(0)">
            Spotify <span class="badge-pro badge-primary fw-bold px-2 py-1">PRO</span>
          </span>
        </div>
      </div>
    </div>
    <div class="page-inner">
      <div class="card">
        <div class="card-body mastering-description">
          <div>
            {{ $t('algorithmic_description_1')}}<br/><br/>
            {{ $t('algorithmic_description_2')}}
          </div>
        </div>
      </div>
      <div class="row mb-5 pb-5">
        <div class="col-md-4">
          <div class="card card-pricing">
            <div class="card-header">
              <h4 class="card-title">Small Algorithmic</h4>
              <div class="card-price">
                <span class="price">$159</span>
                <span class="text">usd</span>
              </div>
            </div>
            <div class="card-body">
              <ul class="specification-list">
                <li>
                  <span class="name-specification">{{ $t('target') }}</span>
                  <span class="status-specification">{{ $t('emerging_artists') }}</span>
                </li>
                <li>
                  <span class="name-specification">{{ $t('average_streams') }}</span>
                  <span class="status-specification">9k - 30k</span>
                </li>
              </ul>
            </div>
            <div class="card-footer">
              <button type="button" @click="showPlaylistModal('price_1Of3ToK9qKRAJ5zqM73k7gJ0')" class="btn btn-primary btn-block"><b>{{ $t('start_campaign') }}</b></button>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-pricing">
            <div class="card-header">
              <h4 class="card-title">Advanced Algorithmic</h4>
              <div class="card-price">
                <span class="price">$259</span>
                <span class="text">usd</span>
              </div>
            </div>
            <div class="card-body">
              <ul class="specification-list">
                <li>
                  <span class="name-specification">{{ $t('target') }}</span>
                  <span class="status-specification">PRO Artists</span>
                </li>
                <li>
                  <span class="name-specification">{{ $t('average_streams') }}</span>
                  <span class="status-specification">30k - 90k</span>
                </li>
              </ul>
            </div>
            <div class="card-footer">
              <button @click="showPlaylistModal('price_1Of3WiK9qKRAJ5zqtdoVvYvS')" class="btn btn-primary btn-block"><b>{{ $t('start_campaign') }}</b></button>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-pricing">
            <span class="badge badge-danger badge-popular">{{ $t('most_popular') }}</span>
            <div class="card-header">
              <h4 class="card-title">PRO Algorithmic</h4>
              <div class="card-price">
                <span class="price">$549</span>
                <span class="text">usd</span>
              </div>
            </div>
            <div class="card-body">
              <ul class="specification-list">
                <li>
                  <span class="name-specification">{{ $t('target') }}</span>
                  <span class="status-specification">MEGA Artists</span>
                </li>
                <li>
                  <span class="name-specification">{{ $t('average_streams') }}</span>
                  <span class="status-specification">100k or more!</span>
                </li>
              </ul>
            </div>
            <div class="card-footer">
              <button @click="showPlaylistModal('price_1Of3WyK9qKRAJ5zqBnQghuwk')" class="btn btn-primary btn-block"><b>{{ $t('start_campaign') }}</b></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="modalPlaylist" class="modal" tabindex="-1" role="dialog" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold">
              {{ $t('which_track_promote') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="">{{ $t('spotify_track_url') }}</label>
              <input placeholder="https://open.spotify.com/track/089TiYUXIRA27eLwTR35Zb" v-model="spotifyUrl" type="url" class="form-control">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button @click="redirectToCheckout()" :disabled="!spotifyUrl" type="button" class="btn btn-primary">
              {{ $t('continue') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MainMastering',
  data () {
    return {
      stripe: window.Stripe('pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm'),
      user: {},
      moment,
      selectedPrice: '',
      spotifyUrl: ''
    }
  },
  methods: {
    showPlaylistModal: function (price) {
      window.$(this.$refs.modalPlaylist).modal('show')
      this.selectedPrice = price
    },
    redirectToCheckout: function () {
      const spotifyTrackUrlRegex = /^https:\/\/open.spotify.com\/track\/[A-Za-z0-9]{22}(?:\?si=[A-Za-z0-9_]+)?$/

      if (!this.spotifyUrl) return

      if (!this.spotifyUrl.match(spotifyTrackUrlRegex)) {
        return this.$notify({ message: this.$t('invalid_spotify_url') }, 'warning', 'fa-exclamation')
      }

      if (this.$user && this.$user.role === 'admin') {
        this.selectedPrice = 'price_1Of4w8K9qKRAJ5zqLPejzo4u'
      }

      this.stripe.redirectToCheckout({
        lineItems: [{ price: this.selectedPrice, quantity: 1 }],
        mode: 'payment',
        customerEmail: this.user.email,
        successUrl: `https://indiefy.net/v1/api/user/promotion-checkout?session_id={CHECKOUT_SESSION_ID}&track_url=${this.spotifyUrl}`,
        cancelUrl: 'https://' + location.hostname + '/tools/spotify-promotion?cancelled=1'
      }).then(function (result) {
        if (result.error) {
          alert(result.error.message)
        }
      })

      window.$(this.$refs.modalPlaylist).modal('hide')
    }
  },
  created: function () {
    this.user = this.$user

    if (this.$route.query.success_checkout) {
      this.$notify({ message: this.$t('purchase_success') }, 'success', 'fa-check')
    }
  }
}
</script>

<style scoped>
.pricing-title {
  border: 2px solid white;
  display: inline-block;
  padding: 3px 10px;
  border-radius: 3px;
}

.basic-price {
  font-size: 25px;
}
.pro-price {
  font-size: 45px;
}

.badge-popular {
  position: absolute;
  top: -5px;
  right: -5px;
}

</style>



// WEBPACK FOOTER //
// src/components/SpotifyPromotion.vue